<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button variant="outline-primary">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-icon"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
            v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
          >
            <feather-icon icon="Trash2Icon" />
            <!-- {{ $t("site.bulk_delete") }} -->
          </b-button>
          <b-button
            variant="outline-primary"
            class="btn-icon"
            :class="{ active: itemView == 'DataTable' }"
            @click="setItemView('DataTable')"
          >
            <feather-icon icon="ServerIcon" />
          </b-button>

          <b-button
            variant="outline-primary"
            class="btn-icon"
            :class="{ active: itemView == 'grid-view' }"
            @click="setItemView('grid-view')"
          >
            <feather-icon icon="GridIcon" />
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <input
            type="text"
            autofocus
            class="form-control"
            v-model="search"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-md-1">
        <b-form-checkbox
          v-model="now"
          v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
          value="1"
          unchecked-value="0"
          class="custom-control-dark"
          switch
          inline
          @input="refresh()"
        >
          {{ $t("quran_programs.draft") }}
        </b-form-checkbox>
      </div>
      <div class="col-md-1">
        <b-form-checkbox
          v-model="now"
          v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
          value="2"
          unchecked-value="0"
          class="custom-control-dark"
          switch
          inline
          @input="refresh()"
        >
          حالية
        </b-form-checkbox>
      </div>
      <div class="col-md-1">
        <b-form-checkbox
          v-model="now"
          v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
          value="3"
          unchecked-value="0"
          class="custom-control-dark"
          switch
          inline
          @input="refresh()"
        >
          قادمة
        </b-form-checkbox>
      </div>
      <div class="col-2">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [6, 12, 24, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row" v-if="itemView == 'DataTable'">
      <div class="col-md-12 overflow-auto">
        <b-card>
          <b-table
            :stacked="$mobile == 1"
            responsive
            ref="table"
            class="vuetable"
            sort-by="id"
            sort-desc.sync="false"
            :current-page="currentPage"
            :fields="bootstrapTable.fields"
            :items="dataProvider"
            style="min-height: 250px"
          >
            <template #cell(checkbox)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                <input
                  type="checkbox"
                  v-model="recordIds"
                  :value="data.item.id"
                  @change="selectItem(data)"
                />
                <span></span>
              </label>
            </template>

            <template #cell(room_type)="data">
              <b-badge variant="light-info" v-if="data.item.room_type == 0">
                {{ $t("quran_programs.group") }}
              </b-badge>
              <b-badge variant="light-dark" v-else>
                {{ $t("quran_programs.single") }}
              </b-badge>
            </template>
            <template #cell(active_now)="data">
              <feather-icon
                icon="MonitorIcon"
                size="21"
                class="text-success"
                v-if="activeNow(data.item)"
              />
              <feather-icon
                icon="MonitorIcon"
                size="21"
                class="text-danger"
                v-else
              />
            </template>
            <template #cell(draft)="data">
              <b-form-checkbox
                v-model="data.item.draft"
                value="1"
                unchecked-value="0"
                class="custom-control-dark"
                checked="true"
                name="draft-button"
                switch
                inline
                @change="setDraft(data.item)"
                :disabled="$role == 'student' || $role == 'teacher'"
              >
              </b-form-checkbox>
            </template>
            <template #cell(max_students)="data">
              <span v-if="data.item.max_students == -1"
                >{{ $t("quran_programs.unlimited") }} </span
              ><span v-else> {{ data.item.max_students }} </span>
            </template>
            <template #cell(edit)="data">
              <b-dropdown :text="$t('site.action')" variant="flat-primary">
                <b-dropdown-item
                  :to="{
                    name: 'QuranProgramTiming',
                    params: { id: data.item.id },
                  }"
                >
                  {{ $t("quran_programs.live_meetings") }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  v-b-modal.modal-add-appointment
                  @click="showSchedules(data.item)"
                >
                  {{ $t("quran_programs.add_appointment") }}
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item
                  v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  @click="editItem(data)"
                  variant="warning"
                >
                  <i class="fa fa-edit"></i>
                  {{ $t("site.edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="deleteItem(data)"
                  v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  variant="danger"
                >
                  <i class="fa fa-trash"></i>
                  {{ $t("site.delete") }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </div>
      <!-- end of col -->
    </div>
    <section :class="itemView" v-if="itemView == 'grid-view' && !load">
      <b-card
        v-for="item in data"
        :key="item.id"
        class="card-developer-meetup ecommerce-card"
        no-body
      >
        <div class="item-img text-center">
          <b-img
            :alt="`${item.name}-${item.id}`"
            fluid
            class="card-img-top"
            :src="item.icon_path"
          />
        </div>

        <!-- item Details -->
        <b-card-body>
          <div class="meetup-header d-flex align-items-center">
            <div class="meetup-day">
              <h3 class="mb-0">{{ item.code }}</h3>
            </div>
            <div class="my-auto">
              <b-card-title class="mb-25">
                {{ item.title }}
              </b-card-title>
              <b-card-text class="mb-0">
                <b-badge variant="light-info" v-if="item.room_type == 0">
                  {{ $t("quran_programs.group") }}
                </b-badge>
                <b-badge variant="light-dark" v-else>
                  {{ $t("quran_programs.single") }}
                </b-badge>
                --
                <b-badge variant="light-info">
                  {{ item.category }}
                </b-badge>
              </b-card-text>
            </div>
          </div>
          <hr />
          <b-media no-body>
            <b-media-aside class="mr-1">
              <b-avatar rounded variant="light-primary" size="34">
                <feather-icon icon="MonitorIcon" size="18" />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">{{ $t("quran_programs.active_now") }}</h6>

              <small>
                <feather-icon
                  icon="MonitorIcon"
                  size="21"
                  class="text-success"
                  v-if="activeNow(item)"
                />
                <feather-icon
                  icon="MonitorIcon"
                  size="21"
                  class="text-danger"
                  v-else
                />
              </small>
            </b-media-body>
          </b-media>
          <b-media no-body>
            <b-media-aside class="mr-1">
              <b-avatar rounded variant="light-primary" size="34">
                <feather-icon icon="ArrowUpIcon" size="18" />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">{{ $t("quran_programs.max_students") }}</h6>

              <small>
                <b-badge variant="light-primary">
                  <span v-if="item.max_students == -1"
                    >{{ $t("quran_programs.unlimited") }} </span
                  ><span> {{ item.max_students }} </span>
                </b-badge>
              </small>
            </b-media-body>
          </b-media>
          <b-media no-body>
            <b-media-aside class="mr-1">
              <b-avatar rounded variant="light-info" size="34">
                <feather-icon icon="ClockIcon" size="18" />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">{{ $t("quran_programs.period") }}</h6>

              <small>
                <b-badge variant="light-info">{{ item.period }} </b-badge>
              </small>
            </b-media-body>
          </b-media>
          <hr />
        </b-card-body>

        <!-- item Actions -->
        <div class="item-options text-center">
          <b-button
            variant="relief-success"
            class="btn-wishlist col-6"
            :to="{
              name: 'QuranProgramTiming',
              params: { id: item.id },
            }"
          >
            {{ $t("quran_programs.live_meetings") }}
          </b-button>
          <b-button
            class="btn-wishlist col-6"
            v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
            variant="relief-info"
            v-b-modal.modal-add-appointment
            @click="showSchedules(data.item)"
          >
            {{ $t("quran_programs.add_appointment") }}
          </b-button>
          <b-button
            v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
            class="btn-wishlist col-6"
            @click="editItem(data)"
            variant="relief-warning"
          >
            <i class="fa fa-edit"></i>
            {{ $t("site.edit") }}
          </b-button>
          <b-button
            class="btn-wishlist col-6"
            @click="deleteItem(data)"
            v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
            variant="relief-danger"
          >
            <i class="fa fa-trash"></i>
            {{ $t("site.delete") }}
          </b-button>
        </div>
      </b-card>
    </section>
    <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
    <b-pagination
      size="sm"
      class="dataTables_paginate paging_simple_numbers pagination-warning"
      :total-rows="totalRows"
      :per-page="perPage"
      v-model="currentPage"
      @input="onChangePage(currentPage)"
    >
      <template v-slot:next-text>
        <i class="fas fa-angle-left" />
      </template>
      <template v-slot:prev-text>
        <i class="fas fa-angle-right" />
      </template>
      <template v-slot:first-text>
        <i class="fas fa-step-forward" />
      </template>
      <template v-slot:last-text>
        <i class="fas fa-step-backward" />
      </template>
    </b-pagination>
    <!-- end of row -->
    <b-modal
      id="modal-info"
      ok-only
      ok-variant="info"
      modal-class="modal-info"
      centered
      @hide="hide"
      size="lg"
      :title="title"
    >
      <b-table :stacked="$mobile == 1" :items="users" :fields="userfields">
        <template #cell(checkbox)="data">
          <b-form-checkbox v-model="usersSelelcted" :value="data.item.id">
          </b-form-checkbox>
        </template>
      </b-table>

      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
    </b-modal>
    <b-modal
      id="modal-add-appointment"
      ok-only
      :ok-title="$t('quran_programs.premuim_schedule_save')"
      centered
      @ok="save"
      size="lg"
      :title="$t('quran_programs.add_appointment')"
    >
      <b-row>
        <b-col md="4">
          <b-form-group>
            <h5>تاريخ المقرأة</h5>
            <flat-pickr
              v-model="newDate.startDate"
              class="form-control"
              :config="{ dateFormat: 'Y-m-d' }"
            />
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <b-form-group>
            <h5>موعد المقرأة</h5>
            <b-form-timepicker v-model="newDate.startTime" locale="ar-EG" />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group>
            <h5>عدد اللقاءات</h5>
            <b-input type="number" v-model="newDate.count" />
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <button
            style="margin-top: 20px"
            type="button"
            class="btn btn-block btn-success"
            @click="addDateSchedule()"
          >
            <i class="fa fa-1x fa-plus" aria-hidden="true"></i>
          </button>
        </b-col>
      </b-row>
      <b-row>
        <table class="table table-hover">
          <tr class="text-center">
            <th>#</th>
            <th>{{ $t("quran_programs.day") }}</th>
            <th>{{ $t("quran_programs.hour") }}</th>
            <th>{{ $t("quran_programs.control") }}</th>
          </tr>
          <tbody class="text-center" id="program_schedule_table">
            <tr
              class="text-center"
              v-for="(schedule, index) in schedules"
              :key="schedule.id"
            >
              <th>{{ index + 1 }}</th>
              <th>{{ schedule.day }}</th>
              <th>{{ schedule.hour }}</th>
              <th>
                <button
                  class="btn btn-danger btn-xs"
                  @click="removeScheduleRow(index)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </th>
            </tr>
          </tbody>
        </table>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import controller from "../../../../Controllers/QuranProgramsController";
import UsersController from "@/Controllers/UsersController";
import flatPickr from "vue-flatpickr-component";
import QuranScheduleDateController from "@/Controllers/QuranScheduleDateController";

export default {
  name: "QuranProgramsDataTable",
  props: ["items", "editItem"],
  components: {
    flatPickr,
  },
  data() {
    return {
      dateNtim: null,
      schedules: [],
      itemView: "DataTable",
      controller: new controller(),
      title: "",
      draft: 0,
      newDate: {},
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "code",
            label: this.$i18n.t("site.code"),
            sortable: true,
          },
          {
            key: "title",
            label: this.$i18n.t("quran_programs.program_name"),
            sortable: true,
          },

          {
            key: "category",
            label: this.$i18n.t("quran_programs.category"),
            sortable: true,
          },
          {
            key: "room_type",
            label: this.$i18n.t("quran_programs.room_type"),
            sortable: true,
          },
          // {
          //   key: "rate",
          //   label: this.$i18n.t("quran_programs.rate"),
          //   sortable: false,
          // },
          {
            key: "active_now",
            label: this.$i18n.t("quran_programs.active_now"),
            sortable: false,
          },
          {
            key: "max_students",
            label: this.$i18n.t("quran_programs.max_students"),
            sortable: false,
          },

          {
            key: "draft",
            label: this.$i18n.t("quran_programs.draft"),
            sortable: false,
          },
          //
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectAll: false,

      currentPage: 1,
      select: [],
      page: 1,
      perPage: 6,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      users: {},
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },

        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
      ],
      programSelelcted: {},
      live: [],
      now: 0,
    };
  },
  async created() {
    // this.itemView = "grid-view";
    const itemViewOptions = [
      { icon: "GridIcon", value: "grid-view" },
      { icon: "ListIcon", value: "list-view" },
    ];
    let itemView = localStorage.getItem("itemView");
    if (!itemView) {
      itemView = "DataTable";
    }
    this.itemView = itemView;
    // systemic
    await this.dataProvider(this.params);
    this.live = await new QuranScheduleDateController().GetAll({ live: 1 });
    this.users = await new UsersController().GetAll({
      type: "teacher",
      filter: "quran_program_supervise|1",
    });
  },
  methods: {
    activeNow(item) {
      // const live = this.live.find((a) => a.quran_program_id == item.id);
      // if (live) return true;
      return false;
    },
    async setDraft(item) {
      // if (item.quran_schedule_date_count < 1 && item.draft=="0"){
      //   item.draft=1
      //    return
      //   };
      // console.log(item);

      this.controller.Updata({ id: item.id, draft: item.draft });
    },
    async assignStudents(item, type, title) {
      this.title = title;
      this.programSelelcted = item;

      this.studentsLoad = true;
      this.usersSelelcted = item.teachers.map((item) => item.id);

      this.studentsLoad = false;
    },

    async hide() {
      this.studentsLoad = true;
      await this.controller.AssignTeacher(this.programSelelcted.id, {
        teacher_ids: this.usersSelelcted,
      });
      this.studentsLoad = false;
      this.usersSelelcted = [];
      this.programSelelcted = {};
      this.$refs.table.refresh();
    },
    showSchedules(quranProgram) {
      this.schedules = [];
      this.programSelelcted = quranProgram;
    },
    async save() {
      this.load = true;
      if (this.schedules.length == 0) return;
      await this.controller.Addschedule({
        quran_program_id: this.programSelelcted.id,
        dates: this.schedules,
        bulk: 1,
      });
      this.load = false;
      this.schedules = [];

      this.programSelelcted = {};
      this.$refs.table.refresh();
    },
    addDateSchedule() {
      let date = this.moment(
        this.newDate.startDate + " " + this.newDate.startTime
      );
      let endDate = this.moment(
        this.newDate.startDate + " " + this.newDate.startTime
      );
      date.locale("en");
      for (let index = 0; index < this.newDate.count; index++) {
        if (index != 0) date.add(this.programSelelcted.period, "m");
        this.schedules.push({
          day: date.format("YYYY-MM-DD "),
          hour: date.format("hh:mm A"),
          start: date.format("YYYY-MM-DD HH:mm:ss"),
          end: endDate
            .add(this.programSelelcted.period, "m")
            .locale("en")
            .format("YYYY-MM-DD HH:mm:ss"),
          date: date.format("YYYY-MM-DD"),
        });
      }

      this.dateNtim = null;
    },
    removeScheduleRow(index) {
      this.schedules.splice(index, 1);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      console.log(this.currentPage);
      this.params.currentPage = this.currentPage;
      if (this.$refs.table) this.$refs.table.refresh();
      this.dataProvider(this.params);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await this.controller.GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.filter = "systemic|0";
      if (this.$role == "student") {
        apiParams.filter += "&&draft|1";
      }
      // apiParams.with = [  "quranScheduleDate.students"];
      apiParams.withCount = ["quranScheduleDate"];
      if (this.now == 1) this.draft = 1;
      else {
        this.draft = 0;
      }
      apiParams.now = this.draft;
      if (this.now == 2) apiParams.now = 2;
      return apiParams;
    },
    refresh() {
      this.dataProvider(this.params);
      if (this.$refs.table) this.$refs.table.refresh();
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      this.controller.Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      this.controller.Delete(0, this.recordIds, this.$refs.table);
    },
    setItemView(view) {
      localStorage.setItem("itemView", view);
      this.itemView = view;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/base/pages/app-ecommerce.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>
